import title from '@/layout/components/Sidebar/title'
import { createRouter, createWebHistory, RouterView } from 'vue-router'
/* eslint-disable */
const order = {
  path: '/order',
  name: '订单管理',
  icon: 'FileSearchOutlined',
  component: () => import('@/pages/order/index.vue') 
}

const express = {
  path: '/express',
  name: '快递管理',
  icon: 'NodeIndexOutlined',
  component: () => import('@/pages/express/index.vue')
}

const product = {
  path: '/product',
  name: '产品管理',
  icon: 'ShoppingOutlined',
  children: [
    {
      path: '/product/list',
      name: '产品列表',
      icon: 'ShoppingOutlined',
      component: () => import('@/pages/product/index.vue')
    },
    {
      path: '/product/category',
      name: '产品分类',
      icon: 'ShoppingOutlined',
      component: () => import('@/pages/product/category.vue')
    }
  ]
}

const servProject = {
  path: '/servProject',
  name: '服务产品',
  icon: 'HeartOutlined',
  component: () => import('@/pages/servProject/index.vue')
}

const code = {
  path: '/serv',
  name: '服务管理',
  icon: 'CoffeeOutlined',
  children: [
    {
      path: '/serv/records',
      name: '核销记录',
      meta: {
        title: '核销记录'
      },
      component: () => import('@/pages/code/records.vue')
    },
    {
      path: '/serv/verify',
      name: '核销码',
      meta: {
        title: '核销码'
      },
      component: () => import('@/pages/code/verify.vue')
    }
  ]
}

const activity = {
  path: '/activity',
  name: '活动管理',
  icon: 'FireOutlined',
  component: () => import('@/pages/activity/pintuan.vue')
}


const login = {
  path: '/login',
  name: '登录',
  meta: {
    title: '登录'
  },
  component: () => import('@/pages/login/index.vue')
}

const wxUser = {
  path: '/customer',
  name: '微信用户',
  icon: 'WechatOutlined',
  meta: {
    title: '微信用户'
  },
  component: () => import('@/pages/wx/user.vue')
}

export const dynamicRoute = [order, express, code, activity, product, wxUser, servProject]

export const healthRoute = {
  path: '/health',
  name: 'health',
  meta: {
    title: '健康'
  },
  redirect: '/order',
  component: () => import('@/layout/layout.vue'),
  children: dynamicRoute
}

export const homeRoute = {
  path: '/home',
  name: 'home',
  meta: {
    title: '到家'
  },
  redirect: '/home/config',
  component: () => import('@/layout/layout.vue'),
  children: [
    {
      path: '/home/config',
      name: "配置",
      icon: 'UserOutlined',
      component: () => import('@/pages/home/config/index.vue')
    },
    {
      path: '/home/physio',
      name: "员工管理",
      icon: 'UserOutlined',
      component: () => import('@/pages/home/physio/index.vue')
    },
    {
      path: '/home/customer',
      name: "客户管理",
      icon: 'CustomerServiceOutlined',
      component: () => import('@/pages/home/customer/index.vue')
    },
    {
      path: '/home/server',
      name: '项目管理',
      icon: 'ProjectOutlined',
      component: () => import('@/pages/home/server/index.vue')
    },
    {
      path: '/home/city',
      name: '城市管理',
      icon: 'HomeOutlined',
      component: () => import('@/pages/home/city/index.vue')
    },
    {
      path: '/home/order',
      name: '订单信息',
      icon: 'BorderOutlined',
      component: () => import('@/pages/home/order/index.vue')
    },
    {
      path: '/home/recruit',
      name: '加盟管理',
      icon: 'ReconciliationOutlined',
      component: () => import('@/pages/home/recruit/index.vue')
    },
    {
      path: '/home/recharge',
      name: '充值管理',
      icon:  'MoneyCollectOutlined',
      component: () => import('@/pages/home/recharge/index.vue')
    }
  ]
}


export const systemRoute = {
  path: '/system',
  name: 'system',
  component: () => import('@/layout/layout.vue'),
  redirect: '/system/account',
  children: [
    {
      path: '/system/account',
      name: '账户管理',
      icon: 'UserOutlined',
      component: () => import('@/pages/system/account/index.vue')
    },
    // {
    //   path: '/system/meun',
    //   name: '菜单管理',
    //   meta: {
    //     title: '菜单管理'
    //   },
    //   icon: 'MenuOutlined',
    //   component: () => import('@/pages/system/menu/index.vue')
    // },
    {
      path: '/system/store',
      name: '门店管理',
      meta: {
        title: '门店管理'
      },
      icon: 'MenuOutlined',
      component: () => import('@/pages/system/store/index.vue')
    },
    {
      path: '/system/agent',
      name: '代理商管理',
      meta: {
        title: '代理商管理'
      },
      icon: 'UserOutlined',
      component: () => import('@/pages/system/agent/index.vue')
    }
  ]
}


const _routes = [dynamicRoute, homeRoute, systemRoute ] as any

console.log(_routes)
//  login, homeRoute, systemRoute, ,homeRoute, systemRoute, 
//  ..._routes
export const routes: Array<ROUTER.RoutesProps> = [healthRoute, homeRoute, systemRoute, login]

const baseUri = process.env.NODE_ENV === 'development' ? './' : '/'

const router = createRouter({
  history: createWebHistory(),
  routes: routes
})

console.log(routes)

export default router
